<template>
  <v-dialog :value="dialog"
            width="400"
            @input="onDialogInput">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white"
                class="mr-2">fas {{ icon }}</v-icon> {{ title }}
      </v-card-title>
      <v-card-text class="py-4">
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="accent--text"
               text
               @click="onDialogInput(false)">
          Cancelar
        </v-btn>
        <v-btn class="primary"
               rounded
               :loading="loading"
               @click="onConfirm">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'OK',
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onDialogInput: {
      type: Function,
      required: true,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
